module.exports = __webpack_public_path__ + "static/media/Stellar Vox King Headboard - 180 cm_Light Beige.59c52f37.png";